export default __webpack_public_path__ + "static/s-01-c47951736290bd38c93f18d6941c8b6f.png";